<template>
  <div class="information-system">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/information-system/banner.png" />
    </div>
    <div class="test-system">
      <div class="website-container">
        <h2>有色金属加工企业提供全流程质量检测、判定与管理一体化解决方案</h2>
        <p>全面梳理企业原料检验规范、生产工艺规范和质量检验规范，建立全过程质量管理系统</p>
        <div class="test-info">
          <h2 class="test-title">铝加工检化验管理系统</h2>
          <img alt src="@/assets/images/website/solution/information-system/upper_bracket.png" />
          <div class="test-pic">
            <img src="@/assets/images/website/solution/information-system/part_1_1.png" style="width:23%;" />
            <img src="@/assets/images/website/solution/information-system/part_1_2.png" style="width:44%;margin-left:10px;" />
            <img src="@/assets/images/website/solution/information-system/part_1_3.png" style="width:30%;margin-left:10px;" />
          </div>
        </div>
      </div>
    </div>
    <div class="intelligence-test">
      <div class="website-container">
        <h2>设备关键部位智能监诊系统</h2>
        <img src="@/assets/images/website/solution/information-system/part_2.png" />
        <p>物联网+移动应用的全方位全过程管理模式</p>
        <p>实现对企业的设备维保中的人、物、制度等要素的全面管控</p>
        <Row style="margin-top:30px; ">
          <Col span="7">
            <img src="@/assets/images/website/solution/information-system/part_3_1.png" style="width:98%;" />
            <img alt src="@/assets/images/website/solution/information-system/part_3_2.png" style="width:98%;" />
          </Col>
          <Col span="5" style="margin-left:16px;">
            <img alt src="@/assets/images/website/solution/information-system/part_3_3.png" />
          </Col>
          <Col span="10" style="margin-left:16px;">
            <img alt src="@/assets/images/website/solution/information-system/part_3_4.png" />
          </Col>
        </Row>
      </div>
    </div>
    <div class="energy-management">
      <div class="website-container">
        <h2>能源管理系统</h2>
        <img alt src="@/assets/images/website/solution/information-system/part_4.png" />
      </div>
    </div>
    <div class="supply-chain-management">
      <div class="website-container">
        <h2>供应链管理系统</h2>
        <Row>
          <Col>
            <img alt src="@/assets/images/website/solution/information-system/part_5_1.png" />
          </Col>
          <Col style="margin-left:20px;">
            <img alt src="@/assets/images/website/solution/information-system/part_5_2.png" />
            <div class="supply-chain-menuitem">
              <span>采购管理</span>
              <span>物料管理</span>
              <span>供应商管理</span>
              <span>系统管理</span>
            </div>
            <div class="supply-chain-function">
              <span>供应商注册</span>
              <span>供应商报价</span>
              <span>供应商接单</span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <div class="intelligent-building">
      <div class="website-container">
        <h2>智能楼宇系统</h2>
        <img alt src="@/assets/images/website/solution/information-system/part_6.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style scoped lang="less">
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.test-system {
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  p {
    line-height: 28px;
    text-align: justify;
  }
  .test-info {
    text-align: center;
    .test-title {
      margin: 20px 0 0;
      color: #077ce1;
    }
  }
}
.intelligence-test {
  background: linear-gradient(#f6f7f9, #ffffff);
  padding-top: 30px;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  img {
    width: 100%;
    margin-bottom: 20px;
  }
  p {
    line-height: 28px;
  }
}
.energy-management {
  background: linear-gradient(#f6f7f9, #ffffff);
  padding-top: 30px;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  img {
    width: 100%;
  }
}
.supply-chain-management {
  padding-top: 30px;
  margin-bottom: 20px;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .supply-chain-menuitem {
    text-align: center;
    span {
      line-height: 28px;
      font-size: 18px;
      font-weight: bold;
      text-align: justify;
      margin: 0 16px;
    }
  }
  .supply-chain-function {
    text-align: center;
    span {
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
      text-align: justify;
      padding: 8px 20px;
      margin: 0 26px;
      background-color: #1f7eff;
      color: #ffffff;
      border-radius: 4px;
    }
  }
}
.intelligent-building {
  background: linear-gradient(#f6f7f9, #ffffff);
  padding-top: 20px;
  margin-bottom: 20px;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  img {
    width: 100%;
  }
}
</style>
